const config = {
  keycloak: {
    url: process.env.REACT_APP_KEYCLOAK_URL || 'https://sso.dev.chainsmart.id',
    realm: process.env.REACT_APP_KEYCLOAK_REALM || 'demo',
    clientId: process.env.REACT_APP_KEYCLOAK_CLIENT_ID || 'smartshield-app-dev',
  },
  api: {
    baseUrl: process.env.REACT_APP_API_PURE || 'https://demo.smartshield.api.dev.chainsmart.id/api/',
  },
  app: {
    version: process.env.REACT_APP_VERSION || '1.0.0',
    environment: process.env.REACT_APP_ENVIRONMENT || 'development',
  },
};

export default config;
